import { FunctionComponent, PropsWithChildren, useEffect } from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { useResource, Resources } from "Infrastructure/Translations/Resources";
import { capitalizeFirstLetterOfString } from "Infrastructure/Utils/StringUtils";

const Layout = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;
	background-color: #fafafa;
`;

type Props = { title: string };

export const UnauthenticatedLayout: FunctionComponent<
	PropsWithChildren<Props>
> = (props) => {
	const { title, children } = props;

	const { t } = useResource();

	useEffect(() => {
		const instanceType = capitalizeFirstLetterOfString(
			import.meta.env.VITE_NAME as string
		);
		document.title = `${instanceType} ${t(
			Resources.Common.AppName
		)} | ${title}`;
	}, [title, t]);

	return <Layout>{children}</Layout>;
};
